export enum ClaimAnalyticEnum {
    TotalCost = 1,
    EdVisit = 2,
    AcCost = 3,
    PhCost = 4,
    FfCost = 5,
    BhRtcCost = 6,
}
